import { Link } from "react-router-dom";
import { ArrowRight, FlaskConical } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/context/LanguageContext";

const PICS = ["f-hover", "f-arm", "f-orbit", "f-qubit"];

export const RobotLabBanner = () => {
  const { L } = useLang();
  return (
    <section className="max-w-7xl mx-auto px-5 lg:px-8 py-14" data-testid="home-robot-lab-banner">
      <Reveal>
        <Link to="/robot-lab" className="group relative grid md:grid-cols-[1.1fr_1fr] gap-6 items-center rounded-3xl overflow-hidden bg-[#0A192F] text-white p-7 sm:p-10" data-testid="home-robot-lab-link">
          <div className="absolute inset-0 opacity-[0.12]" style={{ backgroundImage: "linear-gradient(#4FD1C5 1px, transparent 1px), linear-gradient(90deg, #4FD1C5 1px, transparent 1px)", backgroundSize: "40px 40px" }} />
          <div className="relative">
            <span className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-3 py-1 text-xs font-bold text-[#FFD166]"><FlaskConical className="w-3.5 h-3.5" />{L("New · Robot Lab", "नया · रोबोट लैब")}</span>
            <h2 className="mt-4 font-['Outfit'] font-black text-3xl sm:text-4xl">{L("200 projects. 15 free demo labs.", "200 प्रोजेक्ट्स। 15 मुफ़्त डेमो लैब।")}</h2>
            <p className="mt-3 text-slate-300 max-w-md">{L("Fly a drone, steer a robot arm, launch a satellite and train an AI — right in your browser, no login.", "ड्रोन उड़ाएँ, रोबोट आर्म चलाएँ, सैटेलाइट लॉन्च करें और AI ट्रेन करें — ब्राउज़र में, बिना लॉगिन।")}</p>
            <span className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#FF2E63] px-6 py-3 font-bold group-hover:bg-[#007A8A] transition-colors">{L("Open Robot Lab", "रोबोट लैब खोलें")}<ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
          </div>
          <div className="relative grid grid-cols-2 gap-3">
            {PICS.map((p, i) => <img key={p} src={`/robot-lab/${p}.webp`} alt="" loading="lazy" className={`rounded-2xl aspect-[4/3] object-cover border border-white/10 group-hover:scale-[1.02] transition-transform duration-500 ${i % 2 ? "translate-y-4" : ""}`} />)}
          </div>
        </Link>
      </Reveal>
    </section>
  );
};
